import { useChannelContext } from "client/components/channel"
import { useEffect } from "react"

import { useActiveSaleHighlights } from "../hooks"

import TargetCart from "./cart/TargetCart"
import { TargetView, useTargetContext } from "./TargetContext"
import ProductFlow from "./TargetProductFlow"

const CommerceFlow = () => {
  const { channelId } = useChannelContext()
  const { view, setView, setCurrentlySelectedProductId, setAddedProduct } =
    useTargetContext()
  const [activeSale] = useActiveSaleHighlights(channelId)
  const currencyCode = "USD"

  const resetProductPage = () => {
    // On active sale change, or when panel is opened, if only one product,
    // select product. Otherwise, set selected product to null, to return to
    // multiproduct page
    setCurrentlySelectedProductId(
      activeSale?.visibleProductIds.length === 1
        ? activeSale.visibleProductIds[0]
        : null,
    )
    setAddedProduct(null)
  }

  useEffect(() => {
    resetProductPage()
  }, [activeSale?.id])

  if (!activeSale) {
    return null
  }

  if (view === TargetView.CART) {
    return (
      <TargetCart
        showProduct={() => setView(TargetView.PRODUCT)}
        currencyCode={currencyCode}
      />
    )
  }

  return (
    <ProductFlow
      showCart={() => setView(TargetView.CART)}
      currencyCode={currencyCode}
      channelId={channelId}
      resetProductPage={resetProductPage}
    />
  )
}

export default CommerceFlow
